import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class AlphabeticalSearchListComponent extends Vue {
    @Prop({ required: true })
    listSource: 'airports' | 'countries' | 'cities';

    alphabet = {
        'ru': ['A', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ъ', 'Ы', 'Ь', 'Э', 'Ю', 'Я'],
        'en': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    };
    activeLetter: string = this.alphabet[(<any>this).$i18.language][0];
    destinations: api.Destination[] = [];
    requsetInProgress: boolean = false;

    mounted() {
        this.fetchResultByLetter(this.activeLetter);
    }

    fetchResultByLetter(letter: string) {
        this.requsetInProgress = true;

        const destinationService = new api.DestinationService();
        let serviceMethod: string;
        let requestPayload: object;

        switch (this.listSource) {
            case 'airports':
                serviceMethod = 'listAirportsByAlphabet';
                requestPayload = { firstLetterOfAirport: letter };
                break;
            case 'countries':
                serviceMethod = 'listCountriesByAlphabet';
                requestPayload = { firstLetterOfCountry: letter };
                break;
            case 'cities':
                serviceMethod = 'listCitiesByAlphabet';
                requestPayload = { firstLetterOfCity: letter };
                break;
            default:
                throw Error('Property "listSource" is not specified.');
        }

        destinationService[serviceMethod](requestPayload)
            .then((result) => {
                this.activeLetter = letter;
                result && result.length
                    ? this.destinations = result[0].destinations
                    : this.destinations = [];
                this.requsetInProgress = false;
            });
    }

    onLetterClick(letter) {
        this.fetchResultByLetter(letter);
    }
}
